import { entityNameSorter, getProp } from '@/lib/generic.utils'
import { notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
import { agPriceCol, agStartDateCol } from '@/ag-grid/ag-columns'

/** @param {"first" | "second"} whichCol */
const approvedByOrPaymentRegisteredByCol = whichCol => {
  return {
    headerName: whichCol === 'first' ? 'Approved by' : 'Payment registered by',
    field: whichCol === 'first' ? 'created_by' : 'vendor_payment.created_by',
    comparator: entityNameSorter,
    cellRenderer: params => getProp(params.value, 'name', 'N/A'),
    tooltipValueGetter: params => getProp(params.value, 'name', 'N/A'),
    editable: params => (whichCol === 'first' ? true : !!params.data.vendor_payment),
    cellClassRules: {
      'editable-cell': params => (whichCol === 'first' ? true : !!params.data.vendor_payment)
    },
    cellEditorFramework: 'DropdownEditor',
    cellEditorParams: params => ({
      optionsModule: 'subscription-show',
      optionsState: 'users',
      optionLabel: 'name',
      optionValue: 'id',
      withNA: whichCol !== 'first',
      getValue: model => {
        if ([null, undefined].includes(model)) return null
        if (params.value?.id === model.id) return params.value
        return model.id
      }
    })
  }
}

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Vendor',
            field: 'provider.name',
            comparator: entityNameSorter,
            cellRenderer: notAnyValueCheck,
            tooltipValueGetter: notAnyValueCheck
          },
          {
            headerName: 'Invoice',
            field: 'invoice_number',
            editable: true,
            cellClass: ['editable-cell'],
            cellRenderer: notAnyValueCheck,
            tooltipValueGetter: notAnyValueCheck,
            cellEditorFramework: 'TextEditor'
          },

          agStartDateCol({
            headerName: 'Issued on',
            field: 'issue_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          agStartDateCol({
            headerName: 'Due on',
            field: 'due_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          approvedByOrPaymentRegisteredByCol('first'),

          agStartDateCol({
            headerName: 'Approved on',
            field: 'created_at',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          approvedByOrPaymentRegisteredByCol('second'),

          agStartDateCol({
            headerName: 'Payment date',
            field: 'vendor_payment.payment_date',
            editable: params => !!params.data.vendor_payment,
            cellClassRules: {
              'editable-cell': params => !!params.data.vendor_payment
            },
            cellEditorFramework: 'DateEditor'
          }),

          agPriceCol('Amount', 'amount', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          }),

          {
            headerName: 'File',
            field: 'file',
            cellRendererFramework: 'FileCol',
            cellRendererParams: {
              onUpdate: this.updateRow
            }
          },

          {
            headerName: 'Payment ref',
            field: 'vendor_payment.reference',
            editable: params => !!params.data.vendor_payment,
            cellClassRules: {
              'editable-cell': params => !!params.data.vendor_payment
            },
            cellRenderer: params => {
              if (!params.data.vendor_payment) return 'N/A'
              return params.data.vendor_payment.reference || 'N/A'
            },
            tooltipValueGetter: params => {
              if (!params.data.vendor_payment) return 'Vendor payment has not yet been registered through the workflow'
              return params.data.vendor_payment.reference || 'N/A'
            },
            cellEditorFramework: 'TextEditor'
          }
        ],
        defaultColDef: {
          resizable: false,
          floatingFilter: false
        },
        domLayout: 'autoHeight'
      }
    }
  }
}
